import { Component } from '@angular/core';

@Component({
    selector: 'app-qualification-status-widget-demo',
    templateUrl: './qualification-status-widget-demo.component.html',
    styleUrl: './qualification-status-widget-demo.component.scss',
    standalone: false
})
export class QualificationStatusWidgetDemoComponent {
  managerChartData: Array<{ label: string; value: number; persons: string[] }> = [
    { label: '0-33%', value: 0, persons: [] },
    { label: '34-66%', value: 0, persons: [] },
    { label: '67-99%', value: 0, persons: [] },
    { label: '100%', value: 0, persons: [] },
  ];

  private testData = {
    tenantIddTimeMinutesTarget: 1500, // 25 hours
    employeeIddProgresses: [
      { personId: 'Alice Johnson', employeesIddTimeMinutesReached: 300 },   // 20%
      { personId: 'Bob Smith', employeesIddTimeMinutesReached: 750 },       // 50%
      { personId: 'Charlie Brown', employeesIddTimeMinutesReached: 1200 },  // 80%
      { personId: 'Diana Prince', employeesIddTimeMinutesReached: 1500 },   // 100%
      { personId: 'Eve Davis', employeesIddTimeMinutesReached: 1800 },      // 120%
    ],
  };

  constructor() {
    this.customizeChartLabelText = this.customizeChartLabelText.bind(this);
  }

  ngOnInit() {
    this.processData(this.testData);
  }

  private processData(data: any) {
    this.managerChartData.forEach(group => {
      group.value = 0;
      group.persons = [];
    });

    data.employeeIddProgresses.forEach((progress: any) => {
      const percent = (progress.employeesIddTimeMinutesReached * 100) / data.tenantIddTimeMinutesTarget;

      if (percent >= 0 && percent < 34) {
        this.managerChartData[0].value++;
        this.managerChartData[0].persons.push(progress.personId);
      } else if (percent >= 34 && percent < 67) {
        this.managerChartData[1].value++;
        this.managerChartData[1].persons.push(progress.personId);
      } else if (percent >= 67 && percent < 100) {
        this.managerChartData[2].value++;
        this.managerChartData[2].persons.push(progress.personId);
      } else if (percent >= 100) {
        this.managerChartData[3].value++;
        this.managerChartData[3].persons.push(progress.personId);
      }
    });

    this.managerChartData = [...this.managerChartData];
  }

  customizeChartLabelText(arg: any) {
    let value = 0;
    if (arg.pointName === '0-33%') value = this.managerChartData[0].value;
    else if (arg.pointName === '34-66%') value = this.managerChartData[1].value;
    else if (arg.pointName === '67-99%') value = this.managerChartData[2].value;
    else if (arg.pointName === '100%') value = this.managerChartData[3].value;

    return `${arg.pointName} (${value})`;
  }

  customizeManagerChartPoint(pointInfo: any) {
    switch (pointInfo.argument) {
      case '0-33%': return { color: '#f53d3dcc' };
      case '34-66%': return { color: '#e8b34acc' };
      case '67-99%': return { color: '#aed959cc' };
      case '100%': return { color: '#66cc66cc' };
      default: return {};
    }
  }
}
